import React from 'react';

import { CloudDownloadOutlined } from '@mui/icons-material';
import {
  Button,
  CircularProgress,
  Fade,
  FormControl,
  MenuItem,
  Paper,
  Select,
} from '@mui/material';

import { IOrderDocument } from '../../../types/Document';
import './_base.scss';

const options = {
  docTypes: [
    { id: 'all', name: 'All Documents' },
    { id: 'InkSign,NotApplicable', name: 'Ink Sign' },
    { id: 'ESign', name: 'eSign' },
  ],
};

export interface IDocumentsDownloaderProps {
  allSigned: boolean;
  enableRON: boolean;
  fadeDelay?: string;
  fetchingPresignedUrls?: boolean;
  orderId: string | number;
  originalDocuments?: IOrderDocument[];
}

interface ISelected {
  docType: string;
  party: 'all' | { Id: string };
}

function DocumentsDownloader(props: IDocumentsDownloaderProps) {
  const {
    allSigned,
    enableRON,
    orderId,
    fadeDelay,
    fetchingPresignedUrls,
    originalDocuments,
  } = props;

  const [selected, setSelected] = React.useState<ISelected>({
    party: 'all',
    docType: 'all',
  });
  const [selectedOG, setSelectedOG] = React.useState<any>('');

  const handleChange = (value: any, type: 'party' | 'docType' | 'docOG') => {
    if (type === 'party') {
      setSelected({ party: value, docType: selected.docType });
    }
    if (type === 'docType') {
      setSelected({ party: selected.party, docType: value });
    }
    if (type === 'docOG') {
      setSelectedOG(value);
    }
  };
  const downloadOriginalDocs = () => {
    if (originalDocuments) {
      const file = originalDocuments[selectedOG];
      const path = '/order-management/original-document';
      window.open(
        `/view-file?OrderId=${orderId}&ObjectKeysCsv=${file.Name}&path=${path}`
      );
    }
  };

  const downloadPackage = () => {
    const type = selected.docType !== 'all' ? selected.docType : null;
    const path = '/order-management/document-package';
    window.open(
      `/view-file?OrderId=${orderId}${
        type ? `&SigningTypes=${type}` : ''
      }&path=${path}`
    );
  };

  return (
    <Fade in style={{ transitionDelay: fadeDelay ? fadeDelay : '200ms' }}>
      <Paper className='documents-downloader'>
        <div className='title-bar'>Order Documents</div>
        <div className='actions'>
          <div className='action'>
            <h3>Original documents</h3>
            <FormControl className='action-form-control' variant='standard'>
              <Select
                id='OriginalDocuments'
                value={selectedOG}
                onChange={(e: any) => {
                  const newValue = Number(e.target.value);
                  handleChange(newValue, 'docOG');
                }}
                displayEmpty>
                <MenuItem value=''>Select Document</MenuItem>
                {originalDocuments &&
                  originalDocuments.map((item, index) => (
                    <MenuItem key={index} value={index}>
                      {item.Name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
            {!fetchingPresignedUrls && (
              <Button
                onClick={() => downloadOriginalDocs()}
                disabled={
                  fetchingPresignedUrls || typeof selectedOG !== 'number'
                }
                className='loader-button'
                variant='contained'
                color='primary'
                startIcon={<CloudDownloadOutlined />}>
                Download Original
              </Button>
            )}
            {fetchingPresignedUrls && (
              <CircularProgress size={24} className='button-progress' />
            )}
          </div>
          <div className={allSigned ? 'action' : 'action cancel-style'}>
            <h3>Document Packages {allSigned ? '' : '(In Process)'}</h3>
            <FormControl className='action-form-control' variant='standard'>
              <Select
                id='DocumentPackages'
                value={selected.party}
                onChange={(e: any) => {
                  const newValue = e.target.value;
                  handleChange(newValue, 'party');
                }}
                displayEmpty>
                <MenuItem value='all'>All</MenuItem>
              </Select>
            </FormControl>
            <FormControl className='action-form-control' variant='standard'>
              <Select
                value={selected.docType}
                onChange={(e: any) => {
                  const newValue = e.target.value;
                  handleChange(newValue, 'docType');
                }}
                displayEmpty>
                {enableRON ? (
                  <MenuItem value='all'>All Documents</MenuItem>
                ) : (
                  options.docTypes.map((item, index) => (
                    <MenuItem key={index} value={item.id}>
                      {item.name}
                    </MenuItem>
                  ))
                )}
              </Select>
            </FormControl>
            <Button
              onClick={() => downloadPackage()}
              variant='contained'
              color='primary'
              startIcon={<CloudDownloadOutlined />}
              disabled={!allSigned}>
              Download Package
            </Button>
          </div>
        </div>
      </Paper>
    </Fade>
  );
}

export default DocumentsDownloader;
